// navigation/index.tsx
import { getButtonsVariant } from "../../../config/runtimeConfig";
import DesktopNavigation from "./desktop/DesktopNavigation";
import CircularMobile from "./mobile/circular/NavigationButtons";
import FloatingMobile from "./mobile/floating/NavigationButtons";
import MinimalMobile from "./mobile/minimal/NavigationButtons";

export default function Navigation() {
  const variant = getButtonsVariant();

  const MobileComponent =
    {
      circular: CircularMobile,
      floating: FloatingMobile,
      minimal: MinimalMobile,
    }[variant] || CircularMobile;

  return (
    <>
      <DesktopNavigation />
      <MobileComponent />
    </>
  );
}
